import "../styles/Contact.css";
import { useState } from "react";
import axios from "axios";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useTranslation } from "react-i18next";

import {
  FaWhatsapp,
  FaPhoneAlt,
  FaFacebookF,
  FaEnvelope,
  FaInstagram,
  FaTiktok,
} from "react-icons/fa";

function Contact() {
  const { t } = useTranslation();

  const [formData, setFormData] = useState({
    full_name: "",
    company_name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      await axios.post("/api/contact", formData);

      alert(t("contact_success"));

      setFormData({
        full_name: "",
        company_name: "",
        email: "",
        phone: "",
        message: "",
      });
    } catch (error) {
      alert(t("contact_error"));
    }

    setLoading(false);
  };

  const whatsappLink = "https://wa.me/201205585860";

  const callLink = "tel:+201205585860";

  const facebookLink =
    "https://www.facebook.com/share/1CkKahyXtT/";

  const instagramLink =
    "https://www.instagram.com/egyptian_international_?utm_source=qr";

  const tiktokLink =
    "https://www.tiktok.com/@egyption_international?_r=1&_t=ZS-97aWp97XzXO";

  const emailLink =
    "mailto:salesegyptianinternational@gmail.com";

  return (
    <>
      <Navbar />

      <section className="contact-page">

        {/* HERO */}
        <div className="contact-hero">

          <div className="contact-overlay"></div>

          <div className="contact-hero-content">

            <span className="contact-tag">
              {t("contact_company_tag")}
            </span>

            <h1>
              {t("contact_hero_title")}
            </h1>

            <p>
              {t("contact_hero_desc")}
            </p>

          </div>
        </div>

        {/* MAIN CONTACT SECTION */}
        <div className="contact-container">

          {/* LEFT SIDE */}
          <div className="contact-info">

            <div className="section-header">

              <span>
                {t("contact_company_name")}
              </span>

              <h2>
                {t("contact_ready_title")}
              </h2>

              <p>
                {t("contact_ready_text")}
              </p>

            </div>

            {/* INFO CARDS */}
            <div className="info-cards">

              <div className="info-card">

                <div className="info-icon">
                  📞
                </div>

                <div>
                  <h3>
                    {t("contact_phone_title")}
                  </h3>

                  <p>
                   01205585860 - 01144601188
                  </p>
                  <p>
                   01227365534 - 01558712116
                  </p>
                </div>

              </div>

              <div className="info-card">

                <div className="info-icon">
                  📍
                </div>

                <div>
                  <h3>
                    {t("contact_address_title")}
                  </h3>

                  <p>
                    {t("contact_address")}
                  </p>
                </div>

              </div>

              <div className="info-card">

                <div className="info-icon">
                  ✉️
                </div>

                <div>
                  <h3>
                    {t("contact_email_title")}
                  </h3>

                  <p>
                    salesegyptianinternational@gmail.com
                  </p>
                </div>

              </div>

            </div>

            {/* BUTTONS */}
            <div className="contact-buttons">

              <a
                href={whatsappLink}
                target="_blank"
                rel="noreferrer"
                className="contact-btn whatsapp-btn"
              >
                <FaWhatsapp />
                {t("contact_whatsapp")}
              </a>

              <a
                href={callLink}
                className="contact-btn call-btn"
              >
                <FaPhoneAlt />
                {t("contact_call")}
              </a>

              <a
                href={facebookLink}
                target="_blank"
                rel="noreferrer"
                className="contact-btn facebook-btn"
              >
                <FaFacebookF />
                {t("contact_facebook")}
              </a>

              <a
                href={instagramLink}
                target="_blank"
                rel="noreferrer"
                className="contact-btn instagram-btn"
              >
                <FaInstagram />
                {t("contact_instagram")}
              </a>

              <a
                href={tiktokLink}
                target="_blank"
                rel="noreferrer"
                className="contact-btn tiktok-btn"
              >
                <FaTiktok />
                {t("contact_tiktok")}
              </a>

              <a
                href={emailLink}
                className="contact-btn email-btn"
              >
                <FaEnvelope />
                {t("contact_send_email")}
              </a>

            </div>

          </div>

          {/* RIGHT SIDE */}
          <div className="contact-showcase">

            <div className="showcase-card">

              <span className="showcase-badge">
                {t("contact_iso_badge")}
              </span>

              <h2>
                {t("contact_showcase_title")}
              </h2>

              <p>
                {t("contact_showcase_text")}
              </p>

              <div className="features-list">

                <div className="feature-item">
                  <span>✔</span>
                  {t("contact_feature_1")}
                </div>

                <div className="feature-item">
                  <span>✔</span>
                  {t("contact_feature_2")}
                </div>

                <div className="feature-item">
                  <span>✔</span>
                  {t("contact_feature_3")}
                </div>

                <div className="feature-item">
                  <span>✔</span>
                  {t("contact_feature_4")}
                </div>

              </div>

              <a
                href={whatsappLink}
                target="_blank"
                rel="noreferrer"
                className="main-contact-btn"
              >
                {t("contact_start_button")}
              </a>

            </div>

          </div>

        </div>

        {/* CONTACT REQUEST FORM */}
        <section className="contact-form-section">

          <div className="contact-form-container">

            <div className="contact-form-header">

              <span className="contact-form-tag">
                {t("contact_form_company")}
              </span>

              <h2>
                {t("contact_form_title")}
              </h2>

              <p>
                {t("contact_form_description")}
              </p>

            </div>

            <form
              className="contact-request-form"
              onSubmit={handleSubmit}
            >

              {/* FULL NAME */}
              <div className="form-group">

                <label>
                  {t("contact_form_full_name")}
                </label>

                <input
                  type="text"
                  name="full_name"
                  value={formData.full_name}
                  onChange={handleChange}
                  placeholder={t("contact_form_full_name_placeholder")}
                  required
                />

              </div>

              {/* COMPANY NAME */}
              <div className="form-group">

                <label>
                  {t("contact_form_company_name")}
                </label>

                <input
                  type="text"
                  name="company_name"
                  value={formData.company_name}
                  onChange={handleChange}
                  placeholder={t("contact_form_company_name_placeholder")}
                />

              </div>

              {/* EMAIL */}
              <div className="form-group">

                <label>
                  {t("contact_form_email")}
                </label>

                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="example@email.com"
                  required
                />

              </div>

              {/* PHONE */}
              <div className="form-group">

                <label>
                  {t("contact_form_phone")}
                </label>

                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="01XXXXXXXXX"
                />

              </div>

              {/* MESSAGE */}
              <div className="form-group">

                <label>
                  {t("contact_form_message")}
                </label>

                <textarea
                  rows="6"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder={t("contact_form_message_placeholder")}
                ></textarea>

              </div>

              <p className="form-note">
                {t("contact_form_note")}
              </p>

              <button
                type="submit"
                className="submit-contact-btn"
                disabled={loading}
              >
                {loading
                  ? t("contact_form_sending")
                  : t("contact_form_submit")}
              </button>

            </form>

          </div>

        </section>

      </section>

      <Footer />
    </>
  );
}

export default Contact;